module.exports = __webpack_public_path__ + "img/qr_back_img.98b18c2.png";